// store/actions/headerActions.js

export const SET_HEADER_DATA = "SET_HEADER_DATA";
export const LOGOUT_USER = "LOGOUT_USER";

export const setHeaderData = (payload) => ({
  type: SET_HEADER_DATA,
  payload
});

export const logoutUser = () => ({
  type: LOGOUT_USER
});
